import type { ComponentProps, PropsWithChildren, ReactNode } from 'react';

type ModalHeaderProps = PropsWithChildren<ComponentProps<'div'>>;

/**
 * The modal header wrapper.
 *
 * @param root0 input props
 * @param root0.children the children to pass down
 * @returns Header wrapper
 */
export default function ModalHeader({ children, ...props }: ModalHeaderProps): ReactNode {
  return <header {...props}>{children}</header>;
}
